import { Helmet } from 'react-helmet';
import Navbar from '../../Include/Navbar/Navbar';
import Logo from '../../../assets/images/logo_white.svg'
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Numberstate from './Numberstate';
// import Testimonial from './Testimonial'
import Faq from './Faq';
import Contact from './Contact';
import Footer from '../../Include/Footer/Footer';
import seoMetaData from '../../Include/Seo/seoMetaData';
import CookiePopup from '../../Pages/Other/CookiePopup';

export default function Home() {
  const { title, description, keywords } = seoMetaData.home;
  return (
    <>
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/" />
        <meta name="keywords" content={keywords} />
       <script type="application/ld+json" data-react-helmet="true">
{`
  {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CloudKode",
  "url": "https://www.cloudkode.com/",
  "description": "CloudKodeForm offers custom cloud solutions, mobile app development, and digital transformation services to help your business scale and innovate.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.cloudkode.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  },
  "publisher": {
    "@type": "Organization",
    "name": "CloudKodeForm",
    "url": "https://cloudkodeform.com",
    "logo": {
      "@type": "ImageObject",
      "name": "CloudKodeForm",
      "url": "/static/media/logo_white.210461645b0e9241d56c926ddacdd810.svg"
    }
  },
  "sameAs": [
    "https://www.facebook.com/profile.php?id=61566566795061",
    "https://www.instagram.com/cloudkodeform/?hl=en",
    "https://www.linkedin.com/in/cloudkodeform-technologies-13a7282b8/",
    "https://x.com/cloudkodeform"
  ],
  "mainEntity": [
    {
      "@type": "Question",
      "name": "I’m looking for a cloud services provider, how can you help?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer end-to-end cloud solutions including consultation, architecture, deployment, and ongoing management tailored to your business needs."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer support after project completion?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer ongoing support and maintenance packages to ensure your services remain up-to-date and secure."
      }
    },
    {
      "@type": "Question",
      "name": "How secure are your cloud solutions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our cloud solutions follow industry best practices with multi-layered security including encryption, firewalls, and regular audits."
      }
    },
    {
      "@type": "Question",
      "name": "Can you migrate our existing systems to the cloud?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! We specialize in smooth and secure migrations with minimal downtime."
      }
    },
    {
      "@type": "Question",
      "name": "Do you work with startups as well as enterprises?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we tailor our solutions for both startups and large enterprises, with scalable and cost-effective options."
      }
    }
  ]
}`
}
</script>

      </Helmet>

   <Navbar />
   <Hero/>
   <About/>
   <Services/>
   <Numberstate/>
   {/* <Testimonial/> */}
   <Faq/>
   <Contact/>
   <Footer/>
   <CookiePopup />
   </>
  )
}
